// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import { css } from 'styled-components';
import * as mixins from '@helpcenter/styles/src/mixins';
import * as transitions from '@helpcenter/styles/src/transitions';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import type { RichTextAreaWrapperProps } from './styled';

const requestCreateFieldErrorBorder = token('color.border.danger', colors.R500);
const darkerFieldBorderColor = token('color.border.input', colors.N500);

// This fixes an a11y issue by making the borders darker. Also, an outline is added to the editor when it is focused or has an error.
export const getRichTextAreaWrapperStylesWithDarkerBorder = (
    richTextAreaWrapperSelector: string | undefined = undefined
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
) => css<RichTextAreaWrapperProps>`
    ${richTextAreaWrapperSelector || ''} .akEditor {
        ${mixins.borderRadius};

        border: 1px solid;
        /* stylelint-disable scale-unlimited/declaration-strict-value */
        outline: ${(props) => (props.hasError ? `1px solid ${requestCreateFieldErrorBorder}` : 'none')};
        border-color: ${(props) => (props.hasError ? requestCreateFieldErrorBorder : darkerFieldBorderColor)};
        background-color: ${token('color.background.input', colors.N10)};
        ${transitions.fieldHighlightTransition(transitions.speedMs.medium)};
    }
    /* When the editor is rendered with appearance="comment" (it's default appearance) it renders a SecondaryToolbar */
    /* as a sibling which adds extra padding even if it doesn't render the onSave or onCancel buttons unfortunately */
    ${richTextAreaWrapperSelector || ''} .akEditor + div {
        padding: 0;
    }
    /** This targets the tool bar which is renders as the first direct child of the editor's element  */
    ${richTextAreaWrapperSelector || ''} .akEditor > div {
        background-color: ${token('color.background.input', colors.N10)};
        ${transitions.fieldHighlightTransition(transitions.speedMs.medium)};
    }

    ${richTextAreaWrapperSelector || '&'} {
        &:hover {
            .akEditor {
                background-color: ${token('color.background.input.hovered', colors.N30)};
            }
            .akEditor > div {
                background-color: ${token('color.background.input.hovered', colors.N30)};
            }
        }
    }
    ${richTextAreaWrapperSelector || '&'} {
        &:focus-within {
            .akEditor {
                background-color: ${token('color.background.input', colors.N0)};
                border-color: ${token('color.border.focused', colors.B100)};
                outline: 1px solid ${token('color.border.focused', colors.B100)};
            }
            .akEditor > div {
                background-color: ${token('color.background.input', colors.N0)};
            }
        }
    }
`;
